
document.addEventListener('DOMContentLoaded', () => {
  const popup = document.querySelector('popup-promo');
  if (!popup) return;

  // Elements
  const nextStepButton = popup.querySelector('#next-step-button');
  const backButton = popup.querySelector('[data-prev-step]'); // the actual button/link
  const loaderStep = popup.querySelector('.quest-step--load');

  // Safari: Ensure button is disabled IMMEDIATELY before any other code runs
  if (nextStepButton) {
    nextStepButton.setAttribute('disabled', 'disabled');
  }

  // Only real quiz steps (exclude loader)
  const quizSteps = popup.querySelectorAll('.quest-step:not(.quest-step--load)');
  if (quizSteps.length === 0 || !nextStepButton || !backButton) return;

  // Default number of steps to show at once (can be overridden by `data-show-steps`)
  const defaultShowSteps = Math.max(1, parseInt(popup.dataset.showSteps) || 1);
  // Optionally show two steps only when starting at a specific index: `data-double-step-index="1"` (0-based)
  const doubleStepIndex = popup.dataset.doubleStepIndex !== undefined ? parseInt(popup.dataset.doubleStepIndex) : null;

  let currentStepIndex = 0;

  function visibleCountForIndex(index) {
    if (doubleStepIndex !== null && index === doubleStepIndex) return 2;
    return defaultShowSteps;
  }

  // Get current active step index
  function getCurrentIndex() {
    const active = popup.querySelector('.quest-step.active');
    return active ? Array.from(quizSteps).indexOf(active) : 0;
  }

  // Update Continue button (enabled only if each visible step has a selection)
  function updateContinueButton() {
    const count = visibleCountForIndex(currentStepIndex);
    const visibleSteps = [];
    for (let i = currentStepIndex; i < currentStepIndex + count; i++) {
      if (quizSteps[i]) visibleSteps.push(quizSteps[i]);
    }

    // Require each visible step to have a checked input
    const allHaveSelection = visibleSteps.length > 0 && visibleSteps.every(s => s.querySelector('.quest-filter__input:checked'));

    // Safari compatibility: use multiple methods to ensure disabled state
    if (!allHaveSelection) {
      nextStepButton.setAttribute('disabled', 'disabled');
      nextStepButton.style.pointerEvents = 'none';
      nextStepButton.style.opacity = '0.5';
    } else {
      nextStepButton.removeAttribute('disabled');
      nextStepButton.style.pointerEvents = 'auto';
      nextStepButton.style.opacity = '1';
    }
  }

  // Update Back button (disabled on first step, enabled after)
  function updateBackButton() {
    currentStepIndex = getCurrentIndex();

    const isFirstStep = currentStepIndex === 0;

    // Disable button + add visual disabled state
    backButton.disabled = isFirstStep;

    // For <button> it respects disabled, for <a> we add class + prevent click
    if (backButton.tagName === 'A') {
      backButton.style.pointerEvents = isFirstStep ? 'none' : 'auto';
      backButton.style.opacity = isFirstStep ? '0.5' : '1';
    } else {
      backButton.style.opacity = isFirstStep ? '0.5' : '1';
    }
  }

  // Go to specific step index (shows `showStepsCount` consecutive steps starting at index)
  function goToStep(index) {
    if (index < 0) index = 0;
    if (index >= quizSteps.length) index = quizSteps.length - 1;

    quizSteps.forEach(step => step.classList.remove('active'));

    const count = visibleCountForIndex(index);
    for (let i = index; i < index + count && i < quizSteps.length; i++) {
      quizSteps[i].classList.add('active');
    }

    currentStepIndex = index;

    updateContinueButton();
    updateBackButton();

    // Smooth scroll
    popup.querySelector('.popup__content')?.scrollTo({ top: 0, behavior: 'smooth' });
  }

  // Radio selection → enable Continue
  // Safari compatibility: use 'input' event along with 'change' for better radio button detection
  popup.addEventListener('change', (e) => {
    if (e.target.matches('.quest-filter__input')) {
      updateContinueButton();
    }
  });

  popup.addEventListener('input', (e) => {
    if (e.target.matches('.quest-filter__input')) {
      updateContinueButton();
    }
  });

  // CONTINUE BUTTON
  nextStepButton.addEventListener('click', (e) => {
    // Safari: multiple checks for disabled state
    const isDisabled = nextStepButton.hasAttribute('disabled') ||
      nextStepButton.disabled ||
      nextStepButton.style.pointerEvents === 'none';

    if (isDisabled) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      return false;
    }

    currentStepIndex = getCurrentIndex();

    const currentVisible = visibleCountForIndex(currentStepIndex);

    // If this click would advance past the last page of visible quiz steps → handle final redirect
    if (currentStepIndex >= quizSteps.length - currentVisible) {
      const checked = popup.querySelectorAll('.quest-filter__input:checked');
      if (checked.length === 0) return;

      const filters = Array.from(checked)
        .map(input => input.dataset.url)
        .filter(Boolean);

      filters.unshift('filter.v.price.gte=0', 'filter.v.price.lte=145');

      // Show loader (guard if loader element missing)
      quizSteps.forEach(s => s.classList.remove('active'));

      if (loaderStep) {
        loaderStep.classList.add('active');
      } else {
        // Fallback: create a minimal loader element and append it
        const bodyEl = popup.querySelector('.quest-body');
        if (bodyEl) {
          const el = document.createElement('div');
          el.className = 'quest-step quest-step--load active';
          el.innerHTML = '<div><span class="loader-cs"></span><span class="loader-text">Loading...</span></div>';
          bodyEl.appendChild(el);
        }
      }

      setTimeout(() => {
        window.location.href = `${window.location.origin}/collections/all?${filters.join('&')}`;
      }, 600);

      return;
    }

    // Advance by the number of visible steps for the current page
    goToStep(currentStepIndex + currentVisible);
  });

  // BACK BUTTON
  backButton.addEventListener('click', (e) => {
    if (backButton.disabled || (backButton.tagName === 'A' && backButton.style.pointerEvents === 'none')) {
      e.preventDefault();
      return;
    }

    if (currentStepIndex <= 0) return;

    // Move back by one step (keeps navigation predictable when pages have different widths)
    goToStep(currentStepIndex - 1);
  });

  // Initialize: ensure the configured number of steps are visible on open
  currentStepIndex = getCurrentIndex();
  goToStep(currentStepIndex);
});